import { render, staticRenderFns } from "./Joinus.vue?vue&type=template&id=900483b0&scoped=true"
import script from "./Joinus.vue?vue&type=script&lang=js"
export * from "./Joinus.vue?vue&type=script&lang=js"
import style0 from "./Joinus.vue?vue&type=style&index=0&id=900483b0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "900483b0",
  null
  
)

export default component.exports